import styled from '@emotion/styled'

export const MfaOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`
